<template lang="pug">
.mb-3
  v-card
    v-card-title.grey.lighten-4
      .title Events
      v-spacer
      v-btn(icon @click="open = !open"): v-icon {{open ? 'arrow_drop_down' : 'arrow_drop_up'}}
    v-card-text(v-if="open")
      template(v-for="day,i in showDays")
        br(v-if="i")
        v-card
          v-layout(align-center)
            v-flex.shrink(style="min-width: 4em" justify-end)
              .pl-3.text-xs-right
                .title {{day.day}}
                .subheading {{day.month}}
            v-flex
              .my-1.pr-2
                template(v-for="event in day.events")
                  .d-flexx.align-center.mb-1
                    img.mr-2(v-if="event.media" :src="event.media")
                    router-link(:to="contentUrl(event)") {{event.titel}}
      template(v-if="days.length > 7")
        br
        v-btn(@click="showMore = !showMore") {{showMore ? 'Weniger' : 'Mehr'}}

</template>

<script>
const months = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
import ContentUrl from '../../mixins/content-url'

export default {
  mixins: [ContentUrl],
  props: ['extra'],
  data() {
    return {
      open: true,
      showMore: false
    }
  },
  computed: {
    content() {
      return this.extra && JSON.parse(this.extra.content) || {}
    },
    days() {
      return this.content.days || []
    },
    showDays() {
      if (this.showMore) {
        return this.days
      } else {
        return this.days.slice(0, 7)
      }
    },
  },
  methods: {
  }
}
</script>
